import { styled, Box } from '@mui/material';

export const FormTitleStyled = styled('h3')({
  fontFamily: 'Inter',
  fontSize: '19px',
  fontWeight: '600',
  letterSpacing: '0.15px',
});

export const AddProviderFormStyled = styled('div')({
  display: 'flex',
  flexFlow: 'column',
  width: '100%',
  height: 'auto',
  borderRadius: '4px',
  border: '1px solid #BBC1D0',
  borderBottom: 'none',
  justifyContent: 'space-around',
});

export const FormElementStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  borderBottom: '1px solid #BBC1D0',
  padding: '20px',
  '@media (max-width: 743px)': {
    flexFlow: 'column',
  },
});

export const FormAvatarBoxStyled = styled(Box)({
  gap: '8px',
  border: '1px solid #BBC1D0',
  maxHeight: '56px',
  width: 'fit-content',
  maxWidth: '300px',
  borderRadius: '4px',
  padding: '8px 16px 8px 16px',
  display: 'flex',
  alignItems: 'center',

  '& .truncate': {
    maxWidth: '15ch',
    width: 'auto !important',
  },

  '@media (max-width: 743px)': {
    maxWidth: '100%',
    '& .truncate': {
      maxWidth: '20ch',
      width: 'auto !important',
    },
  },
});

export const FormInputFieldWrapperStyled = styled('div')({
  display: 'flex',
  flexFlow: 'column',
  gap: '0',
  justifyContent: 'space-between',
  width: '45%',
  '@media (max-width: 743px)': {
    width: '100%',
  },
});
